import { render, staticRenderFns } from "./ModalsController.vue?vue&type=template&id=050a8cda&"
import script from "./ModalsController.vue?vue&type=script&lang=ts&"
export * from "./ModalsController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports